<template>
  <div class="layer">
    <button type="button" class="btnClose" @click="cancel"></button>
    <div class="inner">
      <h2 class="layerTitle">{{locale.product_promotion_manage}}</h2>
      <p class="mb5">{{locale.message_product_promotion_image}}</p>
      <div class="promotionList">
        <div
          v-for="(item, index) in promotion"
          :key="index"
          :class="{
            invalid: !item.default && (!item.label || !item.icon),
            defaultItem: item.default,
            hasImg: item.icon
          }"
          class="promotionItem">
          <button v-if="!item.default" type="button" class="delItem" @click.stop="delItem(index)"></button>
          <div v-if="item.default">
            <p class="label mb10">{{locale[item.id]}}</p>
            <div class="defaultIcon"><img :src="require(`@/assets/img/product_stkr_${item.id}.png`)" alt="" /></div>
          </div>
          <div v-else>
            <div class="label mb10"><input type="text" class="input" v-model="item.label" placeholder="label"></div>
            <div class="itemIcon">
              <img v-if="item.icon" :src="item.icon" alt="">
              <label class="btnUpload">
                <input type="file" @change="uploadImage(item, $event)">
              </label>
            </div>
            <div v-if="item.icon" class="unitInput iconSize mt10">
              <span class="unitLabel">{{locale.horizontal_size}}</span>
               <input type="text" class="input" v-model="item.size">
              <i class="unit">px</i>
            </div>
          </div>
        </div>
        <div class="promotionItem add">
          <button type="button" class="btnAdd" @click.stop="addItem">+</button>
        </div>
      </div>
      <div class="btns setApply">
        <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique.js'
import regExp from '@/common/regExp'

export default {
  name: 'SetPromotion',
  props: [
    'locale'
  ],
  computed: {
  },
  created () {
    const promotionList = this.$store.getters['product/getProductSetting'].promotion
    this.promotion = promotionList
  },
  data () {
    return {
      promotion: null
    }
  },
  methods: {
    stkrImg (item) {
      let src = null
      if (item.default) {
        src = require(`@/assets/img/product_stkr_${item.id}.png`)
      } else {
        src = item.icon
      }
      return src
    },
    addItem () {
      const newItem = {
        id: UNIQUE.fileid(),
        default: false,
        label: '',
        icon: null,
        size: ''
      }
      this.promotion.push(newItem)
    },
    uploadImage (item, e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          item.icon = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    delItem (index) {
      if (window.confirm(this.locale.confirm_delete)) {
        this.promotion = this.promotion.filter((x, i) => {
          return index !== i
        })
      }
    },
    save () {
      if (window.confirm(this.locale.confirm_save)) {
        const settings = this.$store.getters['product/getProductSetting']
        const data = {
          ...settings,
          promotion: this.promotion
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('product/setProductSetting', data).then(() => {
          alert(this.locale.complete_save)
          this.$emit('updatePromotion')
          this.$store.commit('product/updateSetting', data)
          this.$store.commit('onLoading', false)
        })
      }
    },
    cancel () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.close()
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.promotionList {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 15px;
  row-gap: 15px;
  align-items: start;
  text-align: center;
}
.promotionItem {
  position: relative;
  padding: 30px 10px 10px;
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
  background-color: $color-white;
  &.defaultItem {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  &.add {
    padding: 0;
  }
  &.invalid {
    border-color: rgba($color-red, 0.5);
  }
  &.hasImg {
    .btnUpload {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
      background: none;
      &:before {
        top: 50%;
        left: 50%;
        width: 60px;
        height: 60px;
        border-radius: 100%;
        border: 1px solid $color-lgrey2;
        background-color: $color-white;
        background-size: 24px;
        transform: translate(-50%, -50%);
        opacity: 0.7;
      }
    }
    .itemIcon:hover {
      .btnUpload {
        display: block;
      }
    }
  }
  .btnAdd {
    width: 100%;
    height: 80px;
    font-size: 36px;
    color: $color-lgrey;
  }
  .itemIcon {
    display: grid;
    place-items: center;
    position: relative;
    height: 120px;
  }
  .btnUpload {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid $color-lgrey2;
    background-color: $bg-default;
    cursor: pointer;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_upload_image.svg') 50% 50% / 32px no-repeat;
      opacity: 0.3;
    }
  }
  img {
    max-width: 120px;
    max-height: 120px;
  }
  .delItem {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 12px no-repeat;
    opacity: 0.5;
  }
}
.defaultIcon {
  height: 32px;
  img {
    height: 100%;
  }
}
.setApply {
  width: 180px;
  margin: 30px auto 0;
}
</style>
